export default "__VITE_ASSET__Bn0Zh5dR__"